/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import moment from 'moment';
import {
  FROM_DATE_REQUIRED,
  TO_DATE_REQUIRED,
  FROM_DATE_FORMAT_ERROR,
  TO_DATE_FORMAT_ERROR,
  AS_OF_DATE_REQUIRED,
  DATE_RANGE_INVALID,
  DATE_INVALID_FORMAT_ERROR,
} from '../Errors/constantMessageData';
import {
  qtrMapping,
  qtrMappingToDate,
  monthMappingReverse,
  monthMapping,
  autoFormateDate,
} from './utilities';

// Validate date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits and or a valid quarter and year in the form ‘#Q##  or#Q####’ such as ‘1Q98 or 1Q1998’.';
export const validateDateQuarter = (date, key) => {
  const errors = [];
  const fourDigitYearReg = /^[1-4]Q[1-9][0-9]{3}$/;
  const twoDigitYearReg = /^[1-4]Q[0-9]{2}$/;
  const allowedLength = [6, 4, 10, 7, 5];

  if (date.trim().length === 0) {
    errors.push({
      field: key,
      message: key === 'fromDate' ? FROM_DATE_REQUIRED : TO_DATE_REQUIRED,
    });
  } else if (allowedLength.indexOf(date.length) !== -1) {
    if (date.length === 6) {
      if (!fourDigitYearReg.test(date)) {
        errors.push({
          field: key,
          message:
            key === 'fromDate' ? FROM_DATE_FORMAT_ERROR : TO_DATE_FORMAT_ERROR,
        });
      } else {
      }
    }
    if (date.length === 4) {
      if (!twoDigitYearReg.test(date)) {
        errors.push({
          field: key,
          message:
            key === 'fromDate' ? FROM_DATE_FORMAT_ERROR : TO_DATE_FORMAT_ERROR,
        });
      }
    }

    if (date.length === 10) {
      const dateValue = new Date(date);
      if (dateValue == 'Invalid Date') {
        errors.push({
          field: key,
          message:
            key === 'fromDate' ? FROM_DATE_FORMAT_ERROR : TO_DATE_FORMAT_ERROR,
        });
      }
    }

    if (date.length === 7) {
      let splittedValue = date.split('/');
      splittedValue = `${splittedValue[0]}/01/${splittedValue[1]}`;
      if (new Date(splittedValue) == 'Invalid Date') {
        errors.push({
          field: key,
          message:
            key === 'fromDate' ? FROM_DATE_FORMAT_ERROR : TO_DATE_FORMAT_ERROR,
        });
      }
    }
    if (date.length === 5) {
      let splittedValue = date.split('/');
      splittedValue = `${splittedValue[0]}/01/20${splittedValue[1]}`;
      if (new Date(splittedValue) == 'Invalid Date') {
        errors.push({
          field: key,
          message:
            key === 'fromDate' ? FROM_DATE_FORMAT_ERROR : TO_DATE_FORMAT_ERROR,
        });
      }
    }
  } else {
    errors.push({
      field: key,
      message:
        key === 'fromDate' ? FROM_DATE_FORMAT_ERROR : TO_DATE_FORMAT_ERROR,
    });
    // if (key === 'fromDate') {
    //   errors.push({
    //     field: key,
    //     message: errorMessage,
    //   });
    // }
    // if (key === 'toDate' && date.trim() !== '') {
    //   errors.push({
    //     field: key,
    //     message: errorMessage,
    //   });
    // }
  }
  return errors;
};

// Follwoing function convert 01/01/1991 to 01-JAN-1991
export const quarterToDate = (input, type) => {
  let output = '';
  if (input.length === 4) {
    const splitInput = input?.split('Q');
    if (type === 'toDate') {
      const qtrLastDay = moment()
        .quarter(moment(parseInt(splitInput[0])))
        .endOf('quarter')
        .format('MM/DD/YYYY');

      output = `${qtrLastDay.split('/')[1]}-${
        qtrMappingToDate[splitInput[0]]
      }-${splitInput[1]}`;
    } else {
      output = `01-${qtrMapping[splitInput[0]]}-${splitInput[1]}`;
    }
  }
  if (input.length === 6) {
    const splitInput = input.split('Q');
    if (type === 'toDate') {
      const qtrLastDay = moment()
        .quarter(moment(parseInt(splitInput[0])))
        .endOf('quarter')
        .format('MM/DD/YYYY');
      output = `${qtrLastDay.split('/')[1]}-${
        qtrMappingToDate[splitInput[0]]
      }-${splitInput[1].substring(2)}`;
    } else {
      output = `01-${qtrMapping[splitInput[0]]}-${splitInput[1].substring(2)}`;
    }
  }

  if (input.length === 10) {
    output = input;
  }
  return output;
};

// Follwoing function convert 01/01/1991 from 01-JAN-1991
export const convertStringDate = (input) => {
  let output = '';
  const splitInput = input.split('-');
  const year =
    parseInt(splitInput[2]) > 90 ? `19${splitInput[2]}` : `20${splitInput[2]}`;
  output = `${monthMappingReverse[splitInput[1]]}/${splitInput[0]}/${year}`;
  return output;
};

export const compareDate = (date1, date2) => {
  if (date1.length === 10) {
    return new Date(date1) > new Date(autoFormateDate(date2));
  }
  if (date1.length == 6) {
    const qtrDate1 = moment(date1, 'QYYYY');
    const qtrDate2 = moment(date2, 'QYYYY');
    return new Date(qtrDate1._d) > new Date(qtrDate2._d);
  }
  return 0;
};

// Validate date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits and or a valid quarter and year in the form ‘#Q##  or#Q####’ such as ‘1Q98 or 1Q1998’.';
export const validateDate = (date, key) => {
  const errors = [];

  if (date.trim().length === 0) {
    errors.push({
      field: key,
      message: AS_OF_DATE_REQUIRED,
    });

    return errors;
  }
  if (date.length === 10) {
    const dateValue = new Date(date);
    if (dateValue == 'Invalid Date') {
      errors.push({
        field: key,
        message: DATE_INVALID_FORMAT_ERROR,
      });
    }
  } else {
    errors.push({
      field: key,
      message: DATE_INVALID_FORMAT_ERROR,
    });
  }
  return errors;
};

export const formatDateUnix = (unixTimestamp) => {
  const dateObject = new Date(unixTimestamp);
  const year = dateObject.getFullYear();
  const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(dateObject.getDate()).padStart(2, '0');

  return `${month}/${day}/${year}`;
};
